























































import Vue from 'vue';
import { routes } from '@/router';
import AuthModule from '@/context/security/store';
import { getModule } from 'vuex-module-decorators';

export default Vue.extend({
  name: 'App',
  components: {},
  data: () => ({
    drawer: false,
    //
  }),
  computed: {
    items: () => {
      return routes.filter(r => r.visible);
    },
    isAuthenticated: () => {
      const authModuleInstance = getModule(AuthModule);
      return authModuleInstance.isAuthenticated;
    }
  },
  methods: {
    filteredChildren(item: any) {
      return item.children.filter((c: any) => c.visible);
    }
  }

});
